﻿export const getSatser = async (): Promise<SatserUtlandModel> => {
    const response = await fetch('/api/mt1535/satser/utlandsatser');

    if (!response.ok) {
        throw response;
    }

    return await response.json();
};

export interface SatserUtlandModel {
    SATS_ST01_SKOLEPENGESTOTTE_MAKS_PER_AR_NORDEN: number;
    SATS_ST01_MAKS_BASISSTOTTE_DAG: number;
    SATS_ST01_REISETILSKUDD_NORD_OG_MELLOM_AMERIKA: number;
    SATS_ST01_REISETILSKUDD_ASIA: number;
    SATS_ST01_REISETILSKUDD_OSEANIA: number;
    SATS_ST01_REISETILSKUDD_AFRIKA: number;
    SATS_ST01_REISETILSKUDD_SOR_AMERIKA: number;
    SATS_ST01_REISETILSKUDD_EUROPA: number;
    SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR: number;
    SATS_ST01_TILLEGGSLAAN_MAKS_PER_AAR: number;
    SATS_ST01_TILLEGGSTIPEND_MAKS_PER_AAR: number;
    SATS_ST01_SKOLEPENGEGRUNNLAG_STIPEND_MAKS_PER_AAR: number;
    SATS_ST01_STIPENDTILUTVEKSLING_DAGSATS: number;
}
